import { EditLocationCalculateETARequest, Location } from 'planning-portal-library/src/lib/core/domain';
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base";
import { BulkUpdateLocationRequest } from "../../domain/requests/locations/bulk-update-location.request";
import { LocationsRepository } from "../../repositories";



@Injectable({ providedIn: 'root' })
export class EditLocationCalculateJobETAUsecase implements UseCase<EditLocationCalculateETARequest, boolean> {

  constructor(private locationRepository: LocationsRepository) {
  }

  execute(params: EditLocationCalculateETARequest): Observable<boolean> {
    return this.locationRepository.editLocationCalculateJobETA(params);
  }

}
